module.exports = __webpack_public_path__ + "img/traveller-inactive.5d97f653.svg";